import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import CalendarModal from '.';
import {generateUUID} from '../../../../common/utils/functions';
import {modalDataInit} from '../../../../data/constants/input';
import {ModalDataI} from '../../../../data/types/interface/input';
import {TitleLabel} from '../InputField/TitleLabel';
import styles from './styles';

export interface itemI {
  id: string;
  value: Date;
}
interface MultiDatePickerProps {
  label?: string;
  required?: boolean;
  listDate: Array<itemI>;
  onChange: (list: Array<itemI>) => void;
  error?: string;
  showError?: boolean;
  min?: Date; // Add min date prop
  max?: Date; // Add max date prop
  disabled?: boolean;
}
export const MultiDatePicker = ({
  label,
  required,
  listDate,
  onChange,
  error,
  showError,
  min,
  max,
  disabled = false,
}: MultiDatePickerProps) => {
  const [modalData, setModalData] = React.useState<ModalDataI>({
    ...modalDataInit,
  });

  const handleAddDate = (value: Date) => {
    !disabled && onChange([...listDate, {id: generateUUID(), value: value}]);
  };
  const handleChange = (id: string, value: Date) => {
    !disabled &&
      onChange([
        ...listDate.map((item: itemI) => {
          if (id !== item.id) {
            return item;
          } else {
            return {
              id: id,
              value: value,
            };
          }
        }),
      ]);
  };
  const handleRemoveDate = (id: string) => {
    !disabled && onChange([...listDate.filter((elt: itemI) => elt.id !== id)]);
  };

  return (
    <View style={styles.multiDatePicker.container}>
      <TitleLabel label={label} required={required} />
      <TouchableOpacity
        onPress={() => {
          !disabled &&
            setModalData({
              status: true,
              value: undefined,
              onChange: handleAddDate,
            });
        }}
        style={[
          styles.multiDatePicker.listContainer,
          {backgroundColor: disabled ? '#f2f2f2' : '#fff'},
        ]}>
        {listDate.length
          ? listDate.map((item: itemI, index: number) => {
              return (
                <TouchableOpacity
                  style={styles.multiDatePicker.itemContainer}
                  key={`date-${index}`}
                  onPress={() =>
                    setModalData({
                      status: true,
                      value: item.value,
                      onChange: (value: Date) => handleChange(item.id, value),
                    })
                  }>
                  <TouchableOpacity
                    style={styles.multiDatePicker.itemCloseButton}
                    onPress={() => handleRemoveDate(item.id)}>
                    <Text>X</Text>
                  </TouchableOpacity>
                  <Text style={styles.multiDatePicker.itemStyle}>
                    {dayjs(item.value).format('DD/MM/YYYY')}
                  </Text>
                </TouchableOpacity>
              );
            })
          : null}
      </TouchableOpacity>
      {required && showError && error !== '' ? (
        <Text style={styles.multiDatePicker.textError}>{error}</Text>
      ) : null}
      <CalendarModal
        modalVisible={modalData.status}
        onClose={() => setModalData({...modalDataInit})}
        value={modalData.value}
        onChange={modalData.onChange}
        min={min}
        max={max}
      />
    </View>
  );
};

export default MultiDatePicker;
